import '../node_modules/bootstrap/scss/bootstrap.scss' 
import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import sostenibilidad from './img/sostenibilidad.png'
import especiales from './img/especiales.jpg'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

import Velocity from 'velocity-animate';

import Viewer, { Worker, SpecialZoomLevel } from '@phuocng/react-pdf-viewer';

import pdfFileLocal from './fichas/Brochure Melon PPEE (2022).pdf'

function App() {

  const DrawCanvasLink = (file) => {
    return (
      <a href={file.url} target="_blank">
        <canvas id="qr-canvas" width="300" height="300"></canvas>
      </a>
      )
  }  

  let pdfFile = 'https://expo-melon.s3.amazonaws.com/fichas/Brochure Melon PPEE (2022).pdf';
  pdfFile = encodeURI(pdfFile);

  let [showPDFModal, setShowPDFModal] = useState(false);

  useEffect(() => {

    if (document.getElementById('qr-canvas')) {
      QRCode.toCanvas(document.getElementById('qr-canvas'), pdfFile, {width: 300}, function (error) {
        if (error) console.error(error)
      });      
    }



  }, [showPDFModal])   

  useEffect(() => {

    let blocks = document.querySelectorAll('.product-block');

    for (let i=0; i<blocks.length;i++) {
      Velocity.animate(blocks[i], { opacity: 1 }, { duration: 250, delay: i*100 });
    }

  }, [])

  return (
    <div className="App container-fluid g-0 fullvh">

    {showPDFModal &&

      <div className="modal-container d-flex flex-column">
        <button style={{position: 'absolute', top: '0vh', left: '93.5vw', zIndex: 9}} className="nav-button" onClick={() => setShowPDFModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
        <div className="modal-content d-flex flex-1 align-items-center justify-center">
          <div className="row">
            <div className="col">
              <div className="bg-white p-3">
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.4.456/build/pdf.worker.min.js">
                    <div style={{ height: '100vh', width: '60vw' }}>
                        <Viewer defaultScale={SpecialZoomLevel.PageFit} fileUrl={pdfFileLocal} />
                    </div>
                </Worker>
              </div>
            </div>
              <div className="col">
                <div className="bg-white p-3">
                  <p>Escanea o presiona para descargar</p>
                  {navigator.userAgent.indexOf('Electron') >= 0 &&
                    <canvas id="qr-canvas" width="300" height="300"></canvas>
                  }
                  {navigator.userAgent.indexOf('Electron') == -1 &&
                    <DrawCanvasLink url={pdfFile} />
                  }
                </div>
              </div>            
          </div>
        </div>
      </div>

    }    

      <div className="row g-0">

        <img src={especiales} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-1">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">


              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                  
                    <h3 className="text-white t-54 pb-3">PROYECTOS EMBLEMÁTICOS</h3>

                  </div>

                  <div className="col-11 d-flex flex-row align-items-center">

                    <div className="row d-flex flex-1">

                      <div className="col">
                        <Link to="/especiales/coyahuasi" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Minera Doña Inés de Collahuasi <span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/caboleones" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Parque Eólico Cabo Leones <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/solar" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Planta de Concentración Solar <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col d-none">
                        <Link to="/especiales/metro" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Proyecto Metro <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/quebrada" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Proyecto Quebrada Blanca <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/teniente" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Proyecto Codelco Teniente <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/pelambres" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Proyecto Minera Los Pelambres <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>                      

                    </div>

                  </div>

                </div>





              </div>
              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white t-54 pb-3">PROYECTOS ESPECIALES</h3>    
                  </div>

                  <div className="col-11 d-flex flex-row align-items-center">

                    <div className="row d-flex flex-1">

                      <div className="col">
                        <Link to="/especiales/mineras" relative="path">
                          <div className="product-block product-block-grow d-flex flex-column">
                            <div className="product-block-upper flex-1">
                              <p className="product-block-bottom-text text-center">Mineros <span className="chevron">></span></p>
                            </div>
                          </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/energias" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Energías <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/obrasciviles" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Obras civiles <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        <Link to="/especiales/moviles" relative="path">
                        <div className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Móviles <span className="chevron">></span></p>
                          </div>
                        </div>
                        </Link>
                      </div>

                      <div className="col">
                        
                        <div onClick={() => setShowPDFModal(true)} className="product-block product-block-grow d-flex flex-column">
                          <div className="product-block-upper flex-1">
                            <p className="product-block-bottom-text text-center">Brochure <span className="chevron">></span></p>
                          </div>
                        </div>
                        
                      </div>                                            

                    </div>

                  </div>
                </div>
                
              </div>

              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;